export const tooltipTheme = {
  tooltip: ({ theme }) => ({
    borderRadius: 4,
    fontSize: 12,
    boxShadow: theme.shadows[4],
  }),
}
